<template>
  <el-row :gutter="20">
    <el-col :xs="{span: 24, offset: 0}" :span="6" :offset="9">
      <h1 class="text-center" style="margin-top: 100px;">{{commerceInfo.commerce_name}}信息库</h1>
      <el-card class="box-card">
        <h2 class="text-center">验证用户</h2>
        <el-form ref="form"  :rules="rules" :model="form">
          <el-form-item prop="mobile">
            <el-input v-model="form.mobile" placeholder="手机号码"></el-input>
          </el-form-item>
          <el-form-item prop="sms_code">
            <el-input placeholder="验证码" v-model="form.sms_code">
              <template slot="suffix">
                <el-button @click="smsCode('form')" type="text" :disabled="!!endtime"><span v-show="endtime">{{endtime}}</span> 获取验证码</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item class="text-center">
            <el-button class="send-btn" type="primary" @click="onSubmit('form')">提交</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import $http from "../../request.js";
import author from "../../author.js";
import { mapState } from 'vuex';
export default {
  name: 'home',
  data(){
    return {
      countDownTimer: 0,
      endtime: 0,
      form: {
        mobile: "",
        sms_code: ""
      },
      rules: {
        mobile: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          { min:11, max: 11, message: '请输入11位手机号', trigger: 'blur' },
          { type:'number', message: '手机号必须是数字', trigger: 'blur', transform(value) {
            return Number(value);
          }}
        ],
        smscode: [
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ]
      }
    };
  },
  computed:{
    ...mapState([
      'commerceInfo'
    ])
  },
  methods: {
    countDown(initNum){
      clearInterval(this.countDownTimer);
      this.endtime = initNum;
      this.countDownTimer = setInterval(()=>{
        this.endtime --;
        if (this.endtime===0) {
          clearInterval(this.countDownTimer);
        }
      }, 1000);
    },
    smsCode(form){
      this.$refs[form].validateField('mobile', (errorMsg) => {
        if (!errorMsg) {
          this.countDown(60);
          $http.post('/api/commons/sms/sendcode', {
            mobile: this.form.mobile
          })
          .then(res=>{
            if (res.data.code==1) {
              this.$message({
                type: 'success',
                message: '验证码发送成功'
              });
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              });
            }
          });
        } else {
          console.log('error !!');
          return false;
        }
        
      });
    },
    onSubmit(form){
      this.$refs[form].validate((valid) => {
        if (valid) {
          $http.post('/api/member/login/loginBySmsCode', this.form)
            .then(res=>{
              if (res.data.code==1) {
                localStorage.setItem('user_token', res.data.data.user_token);
                localStorage.setItem('token_log_time', Date.now());
                author({type: 1}, this.$router);
                this.$message({
                  type: 'success',
                  message: '验证成功'
                });
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.msg
                });
              }
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
  .box-card {
    margin-top: 40px;
  }
  .text-center {
    text-align: center;
  }
  .send-btn {
    font-size: 24px;
    width: 120px;
  }
</style>
